import { appConfig } from '_/config/app';

export default function getStaticQRCode(id: string, type: 'visit' | 'host') {
  return `${appConfig.company.toLowerCase()}://${type}/${id}`;
}
